<template>
  <div class="main-page">
    <center-spinner :loading="loading" />
    <div class="auth-content">
      <h1 class="header-style">
        Enter OTP
      </h1>
      <br>
      <div
        v-if="verificationFailed"
        class="fail-message-style mb-4"
      >
        <p class="fail-style">
          <v-icon
            color="#C62828"
            size="30"
          >
            mdi-alert
          </v-icon> <br>
          {{ verificationFailedMessage }}
        </p>
      </div>
      <p
        v-if="mobileNumber !== null"
        class="subheader-style"
      >
        An OTP has been sent to '{{ mobileNumber }}'. Please enter the code in
        the field below to verify your account.
      </p>
      <div class="otp-style">
        <v-otp-input
          v-model="otp"
          length="4"
          inputmode="numeric"
          color="#000000"
          light
        />
        <span
          class="otp-timer"
        >Time Remaining
          <font class="otp-counter">00:{{ timerCount | formatTimer }}</font><br><font
            class="otp-resend"
            @click="resendOtp()"
          >Resend OTP</font></span>
      </div>
      <v-btn
        :disabled="timerCount === 0"
        class="mt-2 btn-style custom-btn"
        color="#37474F"
        style="width: 100%; height: 50px"
        elevation="0"
        @click="verifyOtp()"
      >
        Next
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="cancelRegister()"
      >
        Cancel
      </v-btn>
    </div>
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
export default {
  name: 'ResetPasswordOtp',
  components: {
    'center-spinner': spinner,
  },
  filters: {
    formatTimer (count) {
      return count < 10 ? '0' + count : count;
    },
  },
  data: () => ({
    loading: false,
    otp: '',
    verificationFailed: false,
    verificationFailedMessage: '',
    mobileNumber: null,
    timerId: null,
    timeLeft: 60,
    timerCount: 0,
    countryName: null,
  }),
  mounted () {
    this.getMobileNumber();
    this.runTimer();
  },
  methods: {
    runTimer () {
      this.timeLeft = 60;
      this.timerId = null;
      this.timerCount = 0;
      this.timerId = setInterval(this.countDown, 1000);
    },
    countDown () {
      if (this.timeLeft === -1) {
        clearInterval(this.timerId);
      } else {
        this.timerCount = this.timeLeft;
        this.timeLeft -= 1;
      }
    },
    async resendOtp () {
      if (this.timerCount !== 0) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: `Please try after ${this.timerCount} seconds.`,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      await this.$store
        .dispatch('passcodereset/confirmMobile', {
          phone_number: this.mobileNumber.toString(),
          })
        .then((response) => {
          this.runTimer();
        })
        .catch((error) => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
    },
    getMobileNumber () {
      this.mobileNumber = this.$route.params.mobileNumber;
    },
    verifyOtp () {
      if (this.otp.length !== 4) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please enter the OTP before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.verificationFailed = false;
      this.loading = true;
      this.$store
        .dispatch('register/verifyOtp', {
          otp_code: this.otp,
          phone_number: this.mobileNumber.toString(),
        })
        .then((response) => {
          this.$router.push({ name: 'New Passcode', params: { mobileNumber: this.mobileNumber.toString() } });
        })
        .catch((error) => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
    },
    cancelRegister () {
      this.loading = true;
      localStorage.removeItem('ph_number');
      setTimeout(() => {
        this.$router.push({ name: 'Register' });
      }, 1000);
    },
  },
};
</script>
<style scoped>
.custom-btn.v-btn--disabled {
  color: rgba(122, 122, 122, 0.493) !important;
  opacity: 1 !important;
  cursor: not-allowed;
  border: 2px solid rgba(122, 122, 122, 0.26);
}
</style>
